// extracted by mini-css-extract-plugin
export var closeButton = "_et-1";
export var closeX = "_et-3";
export var container = "_et-0";
export var image = "_et-2";